import React, { useEffect, useState } from "react";
import { Button, Row, Col } from "antd";
import apiRequest from "../hooks/ApiRequest";
import Layouts from "../components/Layouts";
import logo from "../static/images/New_logo.jpg";
import useDownloadPdf from "../hooks/DownloadPdf";
import { useParams } from "react-router-dom";

const DownloadPolicyDocuments = () => {
  const { id } = useParams(); // policyid from route
  const [policyData, setPolicyData] = useState(null);
  const { generatePdf } = useDownloadPdf();

  useEffect(() => {
    if (id) {
      fetchPolicyDetail(id);
    }
  }, [id]);

  
  const fetchPolicyDetail = async (policyId) => {
    try {
      const response = await apiRequest(
        process.env.REACT_APP_BASE_URL + `/Policy/GetPolicybyId/${policyId}`,
        "GET"
      );
      setPolicyData(response?.data);
    } catch (error) {
      console.error("Error fetching policy data", error);
    }
  };

  if (!policyData) {
    return <p style={{ textAlign: "center" }}>Loading Policy Document...</p>;
  }

  const { policydetail, customerdetail, payment_detail, fetchBrokerDTO } =
    policyData;

  return (
    <Layouts title="Policy Document" classname="dashboard">
      <div className="body-height">
        <div className="bg-white">
          <Row justify="space-between" align="middle" style={{ padding: "10px 20px" }}>
            <Col>
              <h2 style={{ color: "#0C1362", fontWeight: "600" }}>
                Policy Document
              </h2>
            </Col>
            <Col>
              <Button
                className="btn-success"
                size="default"
                onClick={() => generatePdf("policyPdfDiv", "PolicyDocument.pdf")}
              >
                Download PDF
              </Button>
            </Col>
          </Row>

          {/* PDF Body */}
          <div
            id="policyPdfDiv"
            style={{
              background: "#fff",
              padding: "20px",
              margin: "20px",
              border: "1px solid #ddd",
            }}
          >
           
            <Row align="middle" style={{ marginBottom: "20px" }}>
              <Col span={12}>
                <img src={logo} alt="Logo" style={{ width: "200px" }} />
              </Col>
              <Col span={12} style={{ textAlign: "right" }}>
                <h3 style={{ fontWeight: "700" }}>Insurance Policy</h3>
              </Col>
            </Row>

          
            <h4 style={{ background: "#7bdaff", padding: "5px" }}>
              Customer Details
            </h4>
            <Row gutter={16}>
              <Col span={12}>
                <p>Name: {customerdetail?.clientfirstname} {customerdetail?.clientsurname}</p>
                <p>Email: {customerdetail?.clientemailaddress}</p>
                <p>Mobile: {customerdetail?.clientcontactnumber}</p>
                <p>National ID: {customerdetail?.nationalid}</p>
              </Col>
              <Col span={12}>
                <p>Address: {customerdetail?.clientaddress1}</p>
                <p>City: {customerdetail?.city}</p>
                <p>Gender: {customerdetail?.clientgender}</p>
                <p>Age: {customerdetail?.clientage}</p>
              </Col>
            </Row>

          
            <h4 style={{ background: "#7bdaff", padding: "5px", marginTop: "20px" }}>
              Policy Details
            </h4>
            <Row gutter={16}>
              <Col span={12}>
                <p>Policy Number: {policydetail?.policynumber}</p>
                <p>Product: {policydetail?.productname}</p>
                <p>Status: {policydetail?.policystatus}</p>
                <p>Start Date: {policydetail?.policystartdate}</p>
                <p>Expiry Date: {policydetail?.policyexpirytdate}</p>
              </Col>
              <Col span={12}>
                <p>Total Premium: {policydetail?.totalannualpremium}</p>
                <p>Sum Insured: {policydetail?.totalSumInsured}</p> 
                <p>Currency: {policydetail?.currency}</p>
                <p>
                  Broker: {fetchBrokerDTO?.firstName} {fetchBrokerDTO?.lastName} 
                </p>
              </Col>
            </Row>

            {/* Payment Details */}
            <h4 style={{ background: "#7bdaff", padding: "5px", marginTop: "20px" }}>
              Payment Details
            </h4>
            {payment_detail ? (
              <Row>
                <Col span={12}>
                  <p>Payment Status: {payment_detail?.payment_status}</p>
                  <p>Payment Type: {payment_detail?.payment_type}</p>
                  <p>Premium: {payment_detail?.premium}</p>
                  <p>Amount Paid: {payment_detail?.payment_amount}</p> 
                  <p>Payment Date: {policydetail?.paymentDate}</p> 
                </Col>
              </Row>
            ) : (
              <p>No Payment Record Found</p>
            )}

          </div>
        </div>
      </div>
    </Layouts>
  );
};

export default DownloadPolicyDocuments;
